<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CConfigSetting">
      
      <div class="userInfo mt20">
        <el-form :inline="true" :model="userInfo">
          <el-form-item label="审核人：">{{userInfo.name}}</el-form-item>
          <el-form-item label="手机号：">{{userInfo.phone}}</el-form-item>
          <el-form-item><el-button @click="editOpen">修改</el-button></el-form-item>
        </el-form>
      </div>
      <div class="btn mb20">
        <el-button type="primary" @click="openAdd()">添加</el-button>
        <el-button type="warning" @click="previewImg">查看注册二维码</el-button>
      </div>
      <div class="tabList">
        <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="user_name" sortable label="姓名"></el-table-column>
          <el-table-column prop="phone_no" sortable label="手机号码"></el-table-column>
          <el-table-column prop="identity" label="身份证"></el-table-column>
          <el-table-column label="生物特征">
            <template slot-scope="scope">
              <el-button type="text" @click="openBios(scope.$index)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="express_company" label="所属快递公司" sortable></el-table-column>
          <el-table-column label="状态" sortable prop="status">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 1" type="text" @click="statusTips(scope.row.id,scope.row.status)">正常</el-button>
              <el-button v-if="scope.row.status == 0" type="text" @click="statusTips(scope.row.id,scope.row.status)">禁用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging" v-if="total>page">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          @size-change="sizeChange"
          :page-size="page"
          :page-sizes="[10,50,100,1000]"
          layout="total,sizes,prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!--修改审核人-->
      <el-dialog title="修改审核人" :visible.sync="editAuditorDio" width="700px" class="configDio">
        <div class="contDio">
          <div class="tit flex">
            <div>设置审批人：{{auditorform.name}}</div>
          </div>
          <div class="authUserList flex">
            <div class="userTree">
              <div class="titSub">部门列表</div>
              <el-tree
              ref="tree"
              class="defineTree"
              :data="deparList"
              highlight-current
              default-expand-all
              node-key="depart_id"
              :expand-on-click-node="false"
              :props="selectProps2"
              @node-click="getNode">
                <span class="custom-tree-node" slot-scope="{ node,data }">
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span class="label" :class="data.id === auditorform.depart_id ? 'selectedTree' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">人员列表</div>
              <div class="search">
                <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="auditorform.search" @input="searchUser"></el-input>
              </div>
              <el-radio-group class="groupH" v-model="auditorform.user_id" @change="getuserName">
                <el-radio class="dblock" v-for="(item,index) in auditorList" :label="item.user_id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateAuditor">确定</el-button>
          <el-button @click="editAuditorDio = false">取消</el-button>
        </span>
      </el-dialog>

      <!--添加快递员-->
      <el-dialog title="添加快递员" :visible.sync="addKdDio" width="480px">
        <div class="contDio">
          <el-form ref="form2" :rules="rules2" :model="kdform" label-width="120px" >
            <el-form-item label="姓名:" prop="name">
              <el-input v-model="kdform.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-input style="position:fixed;bottom:-9999px"></el-input>
            <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>

            <el-form-item label="手机号码:" prop="phone">
              <el-select v-model="value" placeholder="国家" style="width: 130px;display: inline-block;">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="kdform.phone" placeholder="请输入手机号码" style="width: 185px;display: inline-block;"></el-input>
            </el-form-item>

            <el-form-item label="密码:" prop="password">
              <el-input v-model="kdform.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="身份证:" prop="idCard">
              <el-input v-model="kdform.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="所属快递公司:" prop="company">
              <!-- <el-input v-model="kdform.company" placeholder="请输入所属快递公司"></el-input> -->
              <!--对接了公司列表接口这里就要改为下拉选择-->
              <el-select v-model="kdform.company" placeholder="请选择所属快递公司">
                <el-option v-for="(item,index) in kdform.compList" :label="item.express_name" :value="item.id" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitExpress('form2')">确定</el-button>
          <el-button @click="addKdDio = false">取消</el-button>
        </span>
      </el-dialog>

      <!--查看二维码-->
      <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
        <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
        <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
      </el-dialog>

      <!--更改状态-->
      <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
        <div class="statusCont">
          <div>当前状态为 <b v-if="statusform.status == '0'">禁用</b><b v-else>正常</b></div>
          <div>是否将状态改为 <b v-if="statusform.status == '0'">正常</b><b v-else>禁用</b>？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" v-if="statusform.status == '0'" @click="changeStatus">正 常</el-button>
          <el-button type="primary" v-else @click="changeStatus">禁 用</el-button>
        </span>
      </el-dialog>

      <!--生物特征-->
      <el-dialog title="生物特征" :visible.sync="biosDio" width="400" class="biosDio">
        <el-tabs v-model="tabNum" @tab-click="handleClick">
          <el-tab-pane label="指纹" name="1">
            <el-form ref="form3" :model="form" label-width="60px" class="mt20">
              <el-form-item v-for="(fin,index) in form.finger" :key="index">
                <span slot="label">指纹{{index+1}}:</span>
                <div class="flex">
                  <div class="flexItem">
                    <el-input v-model="fin.fingerprint_id" placeholder="指纹ID"></el-input>
                    <el-input v-model="fin.fingerprint_value" placeholder="指纹特征"></el-input>
                  </div>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addFinger"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delFinger(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="人脸" name="2">
            <el-form ref="form4" :model="form2" label-width="60px" class="mt20">
              <el-form-item label="人脸:">
                <el-upload
                  :action="actionUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="form.dialogImageUrl" alt="">
                </el-dialog>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="员工卡" name="3">
            <el-form ref="form5" :model="form3" label-width="80px" class="mt20">
              <el-form-item v-for="(men,index) in form3.menber" :key="index">
                <span slot="label">员工卡{{index+1}}:</span>
                <div class="flex">
                  <el-input v-model="men.data"></el-input>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addMenber"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delMenber(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="updateUserProfile('3')">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,deepCopy } from "../../../../static/js/utility/utility.js"
  import { bussinessApi,userApi } from "../../../../static/js/api.js"

  var vm;
  export default {
    name: 'CConfigSetting',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        userInfo:{
          id:'',
          user_id:'',
          name:'',
          phone:'',
          department_id:'',
        },
        //选择国家
        options: [{
          value: '选项1',
          label: '中国 +86'
        }, {
          value: '选项2',
          label: '新加坡 +65'
        }],
        value:'', 

        configList:[],//审核记录列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        editAuditorDio:false,//修改审核人弹窗
        auditorList:[],//审核人列表
        deparList:[],//部门树形
        selectProps2:{
          label: 'name',
          id: 'id',
          children: 'children'
        },
        auditorform:{
          id:'',
          user_id:'',
          phone:'',
          depart_id:'',
          search:'',
          name:'',
        },
        rules:{
          user_id:[
            { required: true, message: '请选择审核人', trigger: 'blur' },
          ],
        },
        allUser:[],//所有审核人

        previewDio:false,//预览二维码
        dioImageUrl:'',//二维码地址

        addKdDio:false,//添加快递员弹窗
        kdform:{
          name:'',
          phone:'',
          password:'',
          idCard:'',
          company:'',
          compList:[],
        },
        rules2:{
          name:[
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          phone:[
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            // { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'}
          ],
          password:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { pattern: /^[\w]{6,20}$/,message:'请输入6-20位字母、数字和下划线组合的密码'}
          ],
          idCard:[
            { required: true, message: '请输入身份证号', trigger: 'blur' },
            // { pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message:'请输入正确的身份证号'}
          ],
          company:[
            { required: true, message: '请输入所属公司', trigger: 'blur' },
          ],
        },


        statusDio:false,//修改状态
        statusform:{
          id:'',
          status:'',
        },

        biosDio:false,//生物特征弹窗
        tabNum:'1',//tab默认选中
        form:{
          finger:[{
            fingerprint_id:'',
            fingerprint_value:'',
          }],
        },
        biosform:{
          user_id:''
        },
        
        dialogVisible: false,
        actionUrl:'https://jsonplaceholder.typicode.com/posts/',
        form2:{
          dialogImageUrl: '',
        },
        form3:{
          menber:[{ 
            data:''
          }],
        },

      };
    },
    created: async function () {
      vm = this
      this.getAuditorByOne()
      this.getWarehouse()
    },
    mounted(){
    },
    methods: {
      //打开添加弹窗
      openAdd(){
        vm.addKdDio = true
        vm.getCompanyList()
      },
      //获取快递员列表
      async getCompanyList(){
        const data = {
          'express_state': '1',//状态搜索1可用，2禁用
          'page':1,//当前页
          'perPage':999999,//每页条数
        }
        let res = await bussinessApi.GetExpress(data)
        if(res.meta.code == 200){
          vm.kdform.compList = res.data.list
        }else{
          showToast(res.meta.message)
        }
      },

      //同步当前选中的审批人
      getuserName(val){
        this.auditorform.name = this.auditorList.find(item => item.user_id === val)["user_name"];
      },
      //获取树形节点(添加)
      getNode(node){
        let that = this;
        this.auditorform.depart_id = node.id
        this.getUserKd(node.id)
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
      },
      //更新生物特征
      async updateUserProfile(type){
        let that = this;
        const arr = []
        if(type == '3'){
          for(let i in this.form3.menber){
            arr.push(this.form3.menber[i].data)
          }
        }
        const dataObj = {
          'id': this.biosform.user_id,
          'type': type,//1指纹，2人脸，3员工卡
          'data': arr
        }
        const res = await bussinessApi.updateUserProfile(dataObj)
        if(res.meta.code == 200){
          showToast('更新成功！')
          // that.$message.success('更新成功！')
          that.biosDio = false
          that.getWarehouse()
          // that.getCourierProfile(this.biosform.user_id)
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //打开生物特征弹窗
      openBios(index){
        this.biosform.user_id = this.configList[index].id
        this.getCourierProfile(this.configList[index].id)
        this.biosDio=true
      },
      //获取生物特征
      async getCourierProfile(id){
        let that = this
        this.form3.menber=[{ data:''}]
        const dataObj = {
          'id': id,
        }
        const res = await bussinessApi.getCourierProfile(dataObj)
        if(res.meta.code == 200){
          if(res.data.staffcard !=''){
            this.form3.menber=[]
            for(let i in res.data.staffcard){
              let obj={ data: ''};
              obj.data = res.data.staffcard[i].data
              that.form3.menber.push(obj)
            }
          }
          // console.log(res.data)
          // console.log('aaa',deepCopy(['1','2']))
          // that.form3.menber = res.data.staffcard == '' ? deepCopy(['1','2']) : res.data.staffcard
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //添加员工卡
      addMenber(){
        let obj = {
          data:''
        }
        this.form3.menber.push(obj);
      },
      //删除员工卡
      delMenber(index){
        this.form3.menber.splice(index,1);
      },
      //添加指纹
      addFinger(){
        const obj = {
          fingerprint_id:'',
          fingerprint_value:''
        }
        this.form.finger.push(obj);
      },
      //删除指纹
      delFinger(index){
        this.form.finger.splice(index,1);
      },
      //人脸图片文件列表移除文件时的钩子
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      //人脸图片点击文件列表时的钩子
      handlePictureCardPreview(file) {
        this.form2.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //tab点击
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      //修改状态
      async changeStatus(){
        let that = this
        const data = {
          'id':that.statusform.id,
          'status':that.statusform.status == '0' ?'1':'0',
        }
        const res = await bussinessApi.statusExpress(data)
        if (res.meta.code === 200) {
          showToast('状态修改成功！')
          that.getWarehouse(1)
          that.statusDio = false
        } else {
          showToast(res.meta.message)
        }
      },
      //打开状态修改弹窗
      statusTips(id,status){
        this.statusform.id = id;
        this.statusform.status = status;
        this.statusDio = true
      },
      //添加快递员
      submitExpress(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.addAuditor()
          } else {
            return false;
          }
        });
      },
      async addAuditor(){
        let that = this
        const data = {
          'user_name':that.kdform.name,//用户名
          'phone_no':that.kdform.phone,//手机
          'password':that.kdform.password,//密码
          'identity':that.kdform.idCard,//身份证
          'express_company':that.kdform.company,//所属公司
        }
        const res = await bussinessApi.addAuditor(data)
        if (res.meta.code === 200) {
          showToast('添加成功！')
          that.getWarehouse(1)
          that.addKdDio = false
        } else {
          showToast(res.meta.message)
        }
      },
      //查看二维码
      async previewImg(){
        let that = this;
        const res = await bussinessApi.lookEwmKd()
        if (res.meta.code === 200) {
          that.dioImageUrl = res.data.url
          that.previewDio = true
        } else {
          showToast(res.meta.message)
        }
      },
      //修改审核人
      editAuditor(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.updateAuditor()
          } else {
            return false;
          }
        });
      },
      async updateAuditor(){
        let that = this
        const data = {
          'id':that.auditorform.id,
          'user_id':that.auditorform.user_id
        }
        const res = await bussinessApi.updateAuditor(data)
        if (res.meta.code === 200) {
          showToast('修改成功！')
          that.getAuditorByOne()
          that.editAuditorDio = false
        } else {
          showToast(res.meta.message)
        }
      },
      //打开修改审核人
      editOpen(){
        this.auditorform.id = this.userInfo.id
        this.auditorform.name = this.userInfo.name
        this.auditorform.user_id = this.userInfo.user_id
        this.auditorform.phone = this.userInfo.phone
        // this.getDepartmentInfo()
        this.getDepartmentList()
        this.editAuditorDio = true
      },
      //通过部门获取审批人
      async getUserKd(depart_id){
        let that = this
        const data = {
          'perPage':99999,
          'department_id':depart_id
        }
        const res = await userApi.getUserList(data)
        if (res.meta.code === 200) {
          // that.auditorform.id = ''
          // that.auditorform.phone = ''
          // that.auditorList = res.data.list
          that.allUser = res.data.list
          that.searchUser()
        } else {
          showToast(res.meta.message)
        }
      },
      //搜索筛选
      searchUser(){
        let that = this;
        var allUser = this.allUser
        var searchList = []
        for(var i in allUser){
          if(that.auditorform.search!=''){
            if(allUser[i].user_name.indexOf(that.auditorform.search) != -1 || allUser[i].phone_no.indexOf(that.auditorform.search) != -1){
              searchList.push(allUser[i])
            }
          }else{
            searchList = allUser
          }
        }
        // console.log('searchList',searchList)
        this.auditorList = searchList
      },
      // 获取部门列表
      async getDepartmentList() {
        let that = this
        const res = await userApi.getDepartmentList()
        if (res.meta.code === 200) {
          that.deparList = res.data
          that.auditorform.depart_id = res.data[0].id
          that.getUserKd(res.data[0].id)
        } else {
          showToast(res.meta.message)
        }
      },
      //通过部门id获取详情
      async getDepartmentInfo(){
        let that = this
        const data = {
          'id':that.userInfo.department_id
        }
        let res = await userApi.getDepartmentInfo(data)
        if (res.meta.code === 200) {
          for(let i in res.data.parent){
            that.auditorform.depart_id.push(res.data.parent[i].id)
          }
          that.getUserKd(that.auditorform.depart_id[that.auditorform.depart_id.length-1])
        } else {
          showToast(res.meta.message)
        }
      },
      //审批人信息
      async getAuditorByOne(){
        let that = this;
        const res = await bussinessApi.getAuditorByOne()
        if(res.meta.code == 200){
          that.userInfo.id = res.data.id
          that.userInfo.phone = res.data.phone_no
          that.userInfo.name = res.data.user_name
          that.userInfo.user_id = res.data.user_id
          that.userInfo.department_id = res.data.department_id
        }else{
          showToast(res.meta.message)
        }
      },
      //同步设备类型
      getPhoneExpre(){
        let that = this;
        for(let i in this.auditorList){
          if(that.auditorList[i].user_id == this.auditorform.user_id){
            that.auditorform.phone = that.auditorList[i].phone_no
          }
        }
      },
      //获取快递员列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
        }
        let res = await bussinessApi.kdCourierList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
      sizeChange (val) {
        console.log('val', val)
        this.page = val
        this.getWarehouse(1)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CConfigSetting{
  .fs25{
    font-size:25px;
  }
  .flexItem{
    flex-grow: 1;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .configDio{
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #979797;
      align-items: flex-start !important;
      .titSub{
        height: 30px;
        padding: 0 10px;
        line-height: 30px;
        background: #E8E8E8;
        color: #333;
        box-sizing: border-box;
      }
      .userTree{
        width: 44%;
        height: 330px;
        overflow-y: auto;
        border-right: 1px solid #979797;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          // text-align: center;
          padding: 6px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input{
            width: 70%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
          .sizeDiv{
            margin-left: 10px;
            .el-radio{
              margin-right: 10px;
            }
          }
        }
        .el-radio.dblock{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-radio__label{
            padding-left:16px;
          }
        }
        .el-radio-group.groupH{
          display: block;
          height: 256px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .checkItem{
            width: 33.33%;
            .el-checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CExpress/CExpressList.vue